import { combineLatest, identity, shareReplay } from 'rxjs';
import { distinctUntilChanged, map, tap } from 'rxjs/operators';
import { DEFAULT_COMPARATOR } from './utils';
/**
 * Creates a new `Query` which maps a source value by the provided mapping
 * function.
 *
 * @param query source query
 * @param mapper value mapper
 * @param options options for processing the result value
 */
export function mapQuery(query, mapper, options) {
    const { shareReplayWithRef, buffer } = createShareReplayWithRef();
    let value$ = query.value$.pipe(map(mapper));
    value$ = distinctValue(value$, options === null || options === void 0 ? void 0 : options.distinct).pipe(shareReplayWithRef);
    function get() {
        return buffer.ref ? buffer.ref.value : mapper(query.get());
    }
    return { get, value$ };
}
/**
 * Creates a new `Query` which takes the latest values from source queries
 * and merges them into a single value.
 *
 * @param queries source queries
 * @param merger value merger
 * @param options options for processing the result value
 */
export function mergeQueries(queries, merger, options) {
    const { shareReplayWithRef, buffer } = createShareReplayWithRef();
    let value$ = combineLatest(queries.map((query) => query.value$)).pipe(map((values) => merger(...values)));
    value$ = distinctValue(value$, options === null || options === void 0 ? void 0 : options.distinct).pipe(shareReplayWithRef);
    function get() {
        if (buffer.ref) {
            return buffer.ref.value;
        }
        return merger(...queries.map((query) => query.get()));
    }
    return { get, value$ };
}
function distinctValue(value$, distinct) {
    var _a, _b;
    if (distinct === false) {
        return value$;
    }
    const comparator = (_a = (distinct === true ? undefined : distinct === null || distinct === void 0 ? void 0 : distinct.comparator)) !== null && _a !== void 0 ? _a : DEFAULT_COMPARATOR;
    const keySelector = (_b = (distinct === true ? undefined : distinct === null || distinct === void 0 ? void 0 : distinct.keySelector)) !== null && _b !== void 0 ? _b : identity;
    return value$.pipe(distinctUntilChanged(comparator, keySelector));
}
function createShareReplayWithRef() {
    const buffer = {};
    const shareReplayWithRef = (source$) => source$.pipe(tap({
        next: (value) => (buffer.ref = { value }),
        unsubscribe: () => (buffer.ref = undefined),
    }), shareReplay({ bufferSize: 1, refCount: true }));
    return { shareReplayWithRef, buffer };
}
//# sourceMappingURL=queryMappers.js.map